import { Box, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LineChart from "../../../components/Dashboard/LineChart";
import appcolors from "../../../constants/Colors";
function calculateTotals(data) {
  if (data?.length > 0) {
    let totalAppointments = 0;
    let totalEarning = 0;

    data.forEach((item) => {
      totalAppointments += item.totalAppointments;
      totalEarning += item.totalEarning;
    });

    return {
      totalAppointments: totalAppointments,
      totalEarning: totalEarning,
    };
  } else {
    return 0;
  }
}

function ReportChart({ data }) {
  const [totalData, setTotalData] = useState(null);

  useEffect(() => {
    const total = calculateTotals(data);
    setTotalData(total);
  }, [data]);

  return (
    <Paper sx={{ borderRadius: 1, p: 2, mt: 3 }}>
      <Typography variant="h1" fontSize={"1rem"} fontWeight={600}>
        Total Appointments Earnings
      </Typography>
      <Typography
        variant="body2"
        fontSize={"0.75rem"}
        color={appcolors.crayolaGrey}
      >
        Appointments value :{" "}
        <span
          style={{
            fontSize: "0.875rem",
            fontWeight: "bold",
            color: appcolors.black,
          }}
        >
          SAR {totalData ? totalData.totalEarning : 0}
        </span>
      </Typography>
      <Box height={400}>
        {data?.length > 0 ? (
          <LineChart data={data} />
        ) : (
          <Stack
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "400px",
            }}
          >
            <Typography
              variant="body2"
              fontSize={"1rem"}
              color={appcolors.crayolaGrey}
            >
              No Data found!
            </Typography>
          </Stack>
        )}
      </Box>
    </Paper>
  );
}

export default ReportChart;
